// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ContactPerson } from './contact-person';

/**
 * 
 * @export
 * @interface JuridicalContractorEdit
 */
export interface JuridicalContractorEdit {
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    shortTitle: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    inn: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    legalAddress: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    factAddress: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    site?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    kpp: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    ogrn: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    paymentAccount?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    correspondentAccount?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    bank?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    bik?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    okpo?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    okato?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    okved?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    directorName?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    directorNameInitials?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    directorNameGenitive?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    directorPosition?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    directorPositionGenitive?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    basis: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    type: JuridicalContractorEditTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    responsibleId?: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof JuridicalContractorEdit
     */
    comment?: string;
    /**
     * 
     * @type {ContactPerson}
     * @memberof JuridicalContractorEdit
     */
    contactPerson?: ContactPerson;
    /**
     * 
     * @type {Array<string>}
     * @memberof JuridicalContractorEdit
     */
    studentIds?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum JuridicalContractorEditTypeEnum {
    Juridical = 'juridical',
    Physical = 'physical'
}



